import PlayerData from "../PlayerData";
import { GameCompleteScreen } from "../ui/GameCompleteScreen";
import ActionQueue from "../utils/ActionQueue";
import { Confetti } from "./Confetti";
import { GameState } from "./GameState";
import { PlanckBodyComponent } from "./PlanckBodyComponent";
import { Player } from "./Player";
import { PlayerStateTypes } from "./PlayerStates/PlayerState";
import { RecapPopup } from "./RecapPopup";

export class GameCompleteState extends GameState {

	start(): void {
		PlayerData.Instance.save();
		const previousScale = this.scene.cameraController.targetScale ;
		this.scene.cameraController.targetScale = 1;
		this.scene.cameraController.targetOffsetX = 0;
		const player = this.game.player;
		player.planckBody.velocity.x = Math.min(player.planckBody.velocity.x, 20);
		const queue = new ActionQueue();

		queue.add(complete => player.once(Player.ON_HIT_GROUND, complete));

		const stageLayer = this.scene.scrollingBG.layers.find(l => l.name == "stageLayer");
		const stage = stageLayer.list.find(o => o.name == "stage") as Phaser.GameObjects.Image;
		const pile = stageLayer.list.find(o => o.name == "explosivePile") as Phaser.GameObjects.Image;

		const trumpets = stageLayer.list.filter(o => o.name == "trumpets") as Phaser.GameObjects.Image[];
		trumpets.forEach(t => t.y += 600);
		if (trumpets[0].x < trumpets[1].x) {
			trumpets[0].x -= 600;
			trumpets[1].x += 600;
		} else {
			trumpets[0].x += 600;
			trumpets[1].x -= 600;
		}
		queue.add(complete => {
			player.removeComponent(player.getComponent(PlanckBodyComponent));

			const target = stageLayer.getLocalTransformMatrix().transformPoint(pile.x + pile.width / 2, pile.y, new Phaser.Math.Vector2()) as Phaser.Math.Vector2;

			player.emit(PlayerStateTypes.SmashThroughWall);
			player.playExplosion();
			player.explosionSpine.setScale(0.5);

			const timelineX = this.scene.tweens.createTimeline();
			const timelineY = this.scene.tweens.createTimeline();
			// Bounce 1 ------------------------
			const jumpTime = 750;
			timelineX.add({
				targets: player,
				x: target.x - 5000,
				duration: jumpTime * 1.25,
				onComplete: () => {
					this.scene.soundManager.play("bounceGround");
					player.emit(PlayerStateTypes.NegHit);
					player.playExplosion();
					setTimeout(() => {
						player.emit(PlayerStateTypes.SmashThroughWall);
					}, 100);
				}
			});

			timelineY.add({
				targets: player,
				y: target.y - 1300,
				duration: jumpTime * 1.25 / 2,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});
			timelineY.add({
				targets: player,
				y: target.y - 300,
				duration: jumpTime * 1.25 / 2,
				ease: Phaser.Math.Easing.Quadratic.In,
			});

			// Bounce 2 ------------------------
			timelineX.add({
				targets: player,
				x: target.x - 3500,
				duration: jumpTime,
				onComplete: ()=>{
					player.emit(PlayerStateTypes.NegHit);
					player.playExplosion();
					setTimeout(() => {
						this.scene.soundManager.play("bounceGround");
						player.emit(PlayerStateTypes.SmashThroughWall);
					}, 100);
				}
			});

			timelineY.add({
				targets: player,
				y: target.y - 1100,
				duration: jumpTime / 2.5,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});
			timelineY.add({
				targets: player,
				y: target.y - 300,
				duration: jumpTime / 2.5,
				ease: Phaser.Math.Easing.Quadratic.In,
			});

			// Bounce 2 ------------------------
			timelineX.add({
				targets: player,
				x: target.x - 2500,
				duration: jumpTime,
				onComplete: () => {
					this.scene.soundManager.play("bounceGround");
					player.playExplosion();
					player.emit(PlayerStateTypes.SmashThroughWall);
				},
			});

			timelineY.add({
				targets: player,
				y: target.y - 1000,
				duration: jumpTime / 2,
				ease: Phaser.Math.Easing.Quadratic.Out,

			});
			timelineY.add({
				targets: player,
				y: target.y - 300,
				duration: jumpTime / 2,
				ease: Phaser.Math.Easing.Quadratic.In,
				onComplete: () =>{
					this.scene.cameraController.targetScale = previousScale;
				}
			});

			// Final Trajectory ---------------------
			timelineX.add({
				targets: player,
				x: target.x - 650,
				duration: jumpTime * 1.5,
				onComplete: complete,
			});

			timelineY.add({
				targets: player,
				y: target.y - 1300,
				duration: jumpTime * 0.75,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});
			timelineY.add({
				targets: player,
				y: target.y - 150,
				duration: jumpTime * 0.75,
				ease: Phaser.Math.Easing.Quadratic.In,
			});

			timelineX.play();
			timelineY.play();
		});

		queue.add(complete => {
			this.scene.cameraController.end(stageLayer, stage);

			const player = this.scene.ltGame.player
			player.emit(PlayerStateTypes.Crash);
			pile.setVisible(false);
			const spine = this.scene.add.spine(0, 0, "end-explosion", "hit", false);
			const spineContainer = this.scene.add.spineContainer(player.x, player.y, spine);
			player.parentContainer.add(spineContainer);
			this.scene.tweens.add({
				targets: spine,
				scale: 0,
				alpha: 0,
				duration: 250,
				delay: 500,
				onComplete: complete
			});

			this.scene.soundManager.play("collideTnt");
			const target = stageLayer.getLocalTransformMatrix().transformPoint(stage.x + stage.width / 2, stage.y, new Phaser.Math.Vector2()) as Phaser.Math.Vector2;
			const jumpTime = 750;
			this.scene.tweens.add({
				targets: player,
				x: target.x,
				duration: jumpTime * 1.5,
			});

			this.scene.tweens.add({
				targets: player,
				y: target.y - 1300,
				duration: jumpTime * 0.75,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});
			this.scene.tweens.add({
				targets: player,
				y: target.y - 150,
				duration: jumpTime * 0.75,
				delay: jumpTime * 0.75,
				ease: Phaser.Math.Easing.Quadratic.In,
				onComplete: () => this.scene.soundManager.play("characterStopped"),
			});
		});

		queue.add(complete => {
			const container = this.scene.add.container();
			this.scene.uiContainer.add(container);
			container.setSize(this.scene.viewport.width, this.scene.viewport.height);
			this.scene.addResize(() => {
				this.scene.alignIn.Center(container, this.scene.viewport);
			});
			const emitters = Confetti.create(this.scene, container);
			Confetti.resumeEmitters(emitters);

			let continueFireworks = true;
			const spineContainer = this.scene.add.spineContainer(-this.scene.viewport.width/2, -this.scene.viewport.height/2);
			container.add(spineContainer);
			const spawnFirework = () => {
				const spine = this.scene.add.spine(0, 0, "firework-burst", "burst", false);
				spine.setSkinByName(Phaser.Math.RND.pick(["blue", "red", "yellow"]));
				spine.setPosition(Phaser.Math.RND.realInRange(0, this.scene.viewport.width), Phaser.Math.RND.realInRange(0, this.scene.viewport.height));
				spine.scale = Phaser.Math.RND.realInRange(1, 1.2);
				
				spine.once("complete", () => {
					spine.destroy();
				});
				spineContainer.add(spine);
				this.scene.time.delayedCall(500, () => {
					if (continueFireworks) spawnFirework();
				});
			};
			spawnFirework();
			this.scene.soundManager.play("gameEndFireworks", false, {loop: true});
			this.scene.tweens.add({
				targets: trumpets,
				y: trumpets[0].y - 600,
				duration: 500,
				ease: Phaser.Math.Easing.Back.Out,
			});
			let trumpetAdjust1 = -600;
			let trumpetAdjust2 = 600;
			if (trumpets[0].x < trumpets[1].x) {
				trumpetAdjust1 = 600;
				trumpetAdjust2 = -600;
			}
			this.scene.tweens.add({
				targets: trumpets[0],
				x: trumpets[0].x + trumpetAdjust1,
				duration: 500,
				ease: Phaser.Math.Easing.Back.Out,
			});
			this.scene.tweens.add({
				targets: trumpets[1],
				x: trumpets[1].x + trumpetAdjust2,
				duration: 500,
				ease: Phaser.Math.Easing.Back.Out,
			});
			this.scene.time.delayedCall(2000, () => {
				Confetti.pauseEmitters(emitters);
				continueFireworks = false;
				complete();
			});
		});

		queue.add(() => {
			const screen = new GameCompleteScreen(this.scene, () =>{
				// Stop Fireworks on Recap
				this.scene.soundManager.get("gameEndFireworks")?.destroy();
				const recap = new RecapPopup(this.scene, this.game.getPlayerDistance(), this.game.coins);
				this.scene.uiContainer.add(recap);
				this.scene.addResize(() => {
					this.scene.alignIn.Center(recap, this.scene.viewport);
				});
			}, this.scene);
			this.scene.uiContainer.add(screen);
		});

		queue.start();
	}

}